import { AssetManagementRepository } from '../data/asset-management-repository';
import { DeleteAssetResponse } from '../types/asset-types';

/**
 * Use case for deleting an asset
 */
export class DeleteAssetUseCase {
  constructor(private readonly repository: AssetManagementRepository) {}

  async execute(assetId: number): Promise<DeleteAssetResponse> {
    return this.repository.deleteAsset(assetId);
  }
}
